import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
  TemplateRef,
} from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { DOCUMENT } from "@angular/common";
import { environment } from "../environments/environment";
import { LocalStorageService } from "./core/local-storage.service";
import { UserRole } from "./shared/enum/base.enum";
import { ToastrManager } from "ng6-toastr-notifications";
import { NotifierService } from "angular-notifier";
import { MessagingService } from "./shared/services/messaging-service";

@Component({
  selector: "body",
  templateUrl: "app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  @ViewChild("notificationTemplate", { static: false })
  notificationTemplate: TemplateRef<any>;
  // pushNotificationTemplateModel: PushNotificationTemplateModel =
  //   new PushNotificationTemplateModel();
  details: any;
  constructor(
    @Inject(DOCUMENT) private _document: HTMLDocument,
    private router: Router,
    private localStorageService: LocalStorageService,
    public toastr: ToastrManager,
    private msgService: MessagingService
    // private notifyService: NotifierService
  ) {
    // const userDetail = this.localStorageService.getCurrentUserDetail();
    //    if(userDetail.role !== UserRole.Admin || userDetail.role !== UserRole.SubAdmin ) {
    //   this.toastr.errorToastr('Not a valid user');
    //   this.localStorageService.removeLogin();
    //   this.router.navigate(['login']);
    // }
    // this.msgService.pushNotificationAlert.subscribe((res) => {
    //   this.pushNotificationTemplateModel.eventUserId = res.eventUserId;
    //   this.pushNotificationTemplateModel.icon = res.icon;
    //   this.pushNotificationTemplateModel.notificationHeader =
    //     res.notificationHeader;
    //   this.pushNotificationTemplateModel.notificationBody =
    //     res.notificationBody;
    //   this.pushNotificationTemplateModel.redirectLink = res.redirectLink;
    //   this.showPushNotification();
    // });

    const url = environment.url.substring(0, environment.url.length - 4);
    this._document
      .getElementById("appFavicon")
      .setAttribute("href", url + "default_attachments/vooy/vooy_title.png");
  }

  ngOnInit() {
    this.msgService.getPermission();
    this.msgService.receiveMessage();
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  // closeNotification() {
  //   this.notifyService.hideAll();
  // }

  // showPushNotification() {
  //   //  alert(this.pushNotificationTemplateModel.message);
  //   console.log(this.notificationTemplate);
  //   this.notifyService.show({
  //     message: "test",
  //     type: "test",
  //     template: this.notificationTemplate,
  //   });
  // }
}
